import QueryString from 'qs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import Button from '../../Button';
import ExtendButton from '../../ExtendButton';

interface IProps {
  isExtended: boolean;
  campusDeactived: boolean;
  setIsExtended: (isExtended: boolean) => void;
  setTab: (tab: string) => void;
}

const ClassTopButtons: FC<IProps> = ({ isExtended, setIsExtended, setTab, campusDeactived }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  return (
    <div className="mb-2 row">
      <div className="col-6">
        <ExtendButton
          isExtended={isExtended}
          setIsExtended={setIsExtended}
        />
      </div>
      <div className="col-6 text-right pt-2">
        <Button
          className='btn btn-primary btn-w100p'
          onClick={() => {
            const param = QueryString.stringify({ ...query, tab: 'createClass' });
            history.push(`/class/class?${param}`);
          }}
          text={t('class.class.button4')}
          disabled={campusDeactived}
          writeAuthYn={writeAuthYn}
        />
      </div>
    </div>
  );
}

export default ClassTopButtons;
